import { displayResponseError } from '@/utils/toastUtils.ts';

import type { AxiosError } from 'axios';
import type { ApiError } from '@/types/services/utils/axios.type.ts';

// A 404 on the BO "fiche client" enrichment routes (LCB-FT, questionnaire client, questionnaire
// investisseur, documents KYC) means "not filled in yet" — a normal empty state, not a blocking
// error. Two error body shapes coexist on the backend for these routes:
//   - Format A: { key: "kyc_not_found_error_key", message: "..." }
//   - Format B: { detail: "Client declaration not found" } (plain FastAPI HTTPException)
// Rather than branching on body shape (which is inconsistent), we key off the HTTP status code,
// which is reliable in both cases.
export function isNotFoundError(error: unknown): boolean {
  const axiosError = error as AxiosError | undefined
  return axiosError?.response?.status === 404
}

// For genuine errors (403, 502/503 from Dataleon, network issues, etc.) on these best-effort
// blocks, we still want to surface a toast, but requests are made with `disableGlobalError: true`
// so the axios interceptor doesn't do it automatically — call this explicitly in the catch block.
export function displayNonNotFoundError(error: unknown): void {
  if (!isNotFoundError(error)) {
    displayResponseError(error as AxiosError<ApiError>)
  }
}
